export { TAGS } from './tags';
export type { TagId } from './tags';

export { CATEGORIES } from './categories';
export type { CategoryId, Category } from './categories';

export { AREAS } from './areas';
export type { AreaId } from './areas';

export { TRIED_RATINGS, RATING_OPTIONS } from './ratings';
export type { TriedRatingValue, ReviewRatingValue } from './ratings';

export { DEFAULT_CLIPS } from './default-clips';

export { CATEGORY_QUESTIONS, getQuestionsForCategory, getUnansweredQuestions } from './category-questions';
export type { CategoryQuestion } from './category-questions';

// Profile scales
export {
  HIS_SIZE_SCALE, HIS_GIRTH_SCALE, HIS_CUM_SCALE, HIS_CONSISTENCY_SCALE, HIS_TASTE_SCALE, HIS_PRECUM_SCALE,
  HER_WETNESS_SCALE, HER_SQUIRT_SCALE, HER_SENSITIVITY_SCALE, HER_ORGASM_EASE_SCALE
} from './profile-scales';
export type {
  HisSizeValue, HisGirthValue, HisCumValue, HisConsistencyValue, HisTasteValue, HisPrecumValue,
  HerWetnessValue, HerSquirtValue, HerSensitivityValue, HerOrgasmEaseValue
} from './profile-scales';

// Profile-reactive follow-up questions
export { PROFILE_REACTIVE_QUESTIONS, getTriggeredQuestions } from './profile-reactive-questions';
export type { ProfileReactiveQuestion, TriggeredQuestion } from './profile-reactive-questions';

// Theme colors
export const COLORS = {
  lime: '#c8e265',
  pink: '#f472b6',
} as const;
